export default "__VITE_ASSET__D5ZBCNX9__"